import { ConfigProvider, Input, Select, Form } from "antd";
import { useForm } from "antd/es/form/Form";
import Modal from "antd/es/modal/Modal";
import { modalButtonsTheme } from "components/modals/ModalChrome";
import { useCreateClassType } from "hooks/mutations/classtype";
import {
  CapacityField,
  CreditCostField,
  DurationField,
} from "pages/products/classtype/ClassFormFields";
import { translate } from "shared/languages";
import { ClassCategory } from "shared/types/enum";

interface NewClassModalProp {
  open: boolean;
  onCancel: () => void;
}

const NewClassModal = ({ open = false, onCancel }: NewClassModalProp) => {
  const [form] = useForm();
  const { mutate: createClassType } = useCreateClassType();
  // The capacity field adapts to the selected Jenis Kelas (max cap for Open,
  // exact party size for Private).
  const classType = Form.useWatch("type", form) as ClassCategory | undefined;

  const onSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        createClassType({ ...values });
        onCancel();
      })
      .catch(() => {});
  };

  return (
    // Button system: navy confirm + solid-ink Batal dismiss.
    <ConfigProvider theme={modalButtonsTheme}>
      <Modal
        title={translate("title.create_class")}
        open={open}
        onCancel={onCancel}
        onOk={onSubmit}
        okText={`${translate("button.add")} ${translate("class")}`}
        afterClose={() => form.resetFields()}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          initialValues={{
            max_participants: 1,
            duration: 30,
            credit_cost: 1,
          }}
        >
          <Form.Item
            name="name"
            label={translate("label.class_name")}
            rules={[{ required: true, message: `${translate("form.error.input")} ${translate("label.class_name")}` }]}
          >
            <Input placeholder={`${translate("form.placeholders.enter")} ${translate("label.class_name")}`} />
          </Form.Item>

          <Form.Item name="description" label={translate("label.description")}>
            <Input.TextArea
              autoSize={{ minRows: 3, maxRows: 6 }}
              placeholder={`${translate("form.placeholders.enter")} ${translate("label.description")}`}
            />
          </Form.Item>

          <Form.Item
            name="type"
            label={translate("label.class_type")}
            rules={[{ required: true, message: `${translate("form.error.select")} ${translate("label.class_type")}` }]}
          >
            <Select placeholder={`${translate("form.placeholders.select")} ${translate("label.class_type")}`}>
              {Object.entries(ClassCategory).map(([key, value]) => (
                <Select.Option key={key} value={value}>
                  {key}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <CapacityField classType={classType} />
          <DurationField />
          <CreditCostField />
        </Form>
      </Modal>
    </ConfigProvider>
  );
};
export default NewClassModal;
